// @flow

import React, { Component } from 'react';

import App from './App.jsx';

import type { T_CollectPoint } from './types.js';

import './css/ShowCollectPoint.css';
import { takeDir } from './utils.js';



type T_ShowCollectPointProps = {
  app: App,
  point: T_CollectPoint,
  cond: boolean
};



export default class ShowCollectPoint extends Component<T_ShowCollectPointProps> {
  img_url(): string {
    return `${this.props.app.remote}/collect-foto/${this.props.point.path_predio.slice(6)}/collect/${this.props.point.foto}`;
  }



  open_image = (): void => {
    this.props.app.setState({
      show_jpg_url: this.img_url(),
      show_jpg_title: `Foto ${this.props.point.fmoment.format('DD/MM/YYYY')}`
    });
  };

  collect_upl = (point, fecha): JSX.Element => {
    return (
      <div className='CollectPointUPL'>
        <div className="CollectHeader">
          <p>Punto de Observación</p>
          <p>{fecha}</p>
        </div>

        <div className="CollectBody">
          <p> <b className='CollectProps'>Agricultor:</b> {point.agricultor}</p>
          { !!point.labor && <p> <b className='CollectProps'>Colección vinculada a:</b> {point.labor}</p>}
          { !!point.manejo.cultivo && 
            <div>
              <p> <b className='CollectProps'>Cultivo:</b> {point.manejo.cultivo}</p>
              <p> <b className='CollectProps'>Tipo de Maleza:</b> {point.manejo.tipoMaleza}</p>
              <p> <b className='CollectProps'>Maleza:</b> {point.manejo.maleza}</p>
              <p> <b className='CollectProps'>Estado Fenológico:</b> {point.manejo.fenologico}</p>
              <p> <b className='CollectProps'>Presencia de Maleza:</b> {point.manejo.presencia}</p>
            </div>
          }
          <div className='ColNot'>
            {point.nota.split('\n').map((par, idx) => (
              <p key={idx} className='coll_p_nota'>
                {idx === 0 ? <b className='CollectProps'>Nota:</b> : ''} {par}
              </p>
            ))}
          </div>

          <img src={this.img_url()} alt='' onClick={this.open_image} />

          <div className="upl-logo">
            <img src={require('./css/img/logos/upl.png')} alt="" />
          </div>
        </div>
      </div>
    )
  }

  collect_normal = (point, fecha): JSX.Element => {
    return (
      <div className='CollectPoint'>
        <h1>
          {point.manejos.join(', ')}
        </h1>

        <p>
          <b>Fecha:</b> {fecha}
        </p>

        <p>
          <b>Agricultor:</b> {point.agricultor}
        </p>

        <div className='ColNota'>
          {point.nota.split('\n').map((par, idx) => (
            <p key={idx} className='coll_p_nota'>
              {idx === 0 ? <b>Nota:</b> : ''} {par}
            </p>
          ))}
        </div>

        <img src={this.img_url()} alt='' onClick={this.open_image} />
      </div>
    );
  }

  render() {
    if (!this.props.cond) {
      return null;
    }

    const { point } = this.props,
      fecha = point.fmoment.format('DD/MM/YYYY');

    return (
      <div>
        {
          takeDir(this.props.point.path_predio).includes('/MAPS/UPL')?
            this.collect_upl(point, fecha)
            : this.collect_normal(point, fecha)
        }
      </div>
    )




  }
}



// WEBPACK FOOTER //
// ./src/ShowCollectPoint.jsx